import { render } from "./OurFellows.vue?vue&type=template&id=4a8ad5e4&scoped=true"
import script from "./OurFellows.vue?vue&type=script&lang=js"
export * from "./OurFellows.vue?vue&type=script&lang=js"

import "./OurFellows.vue?vue&type=style&index=0&id=4a8ad5e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8ad5e4"]])

export default __exports__